import Vue from 'vue'

export function getProfileCustomerList(data) {
  return Vue.axios({
    url: '/api/key_customer/list',
    method: 'get',
    params: {
      ...data
    }
  })
}

export function getProfileCustomerListForSale(data) {
  return Vue.axios({
    url: '/api/key_customer/list_sale',
    method: 'get',
    params: {
      ...data
    }
  })
}

export function getProfileCustomerInfo(data) {
  return Vue.axios({
    url: '/api/key_customer/get_info',
    method: 'get',
    params: {
      ...data
    }
  })
}

export function checkProfileCustomerTitle(data) {
  return Vue.axios({
    url: '/api/key_customer/check_exist',
    method: 'post',
    data
  })
}

export function addProfileCustomer(data) {
  return Vue.axios({
    url: '/api/key_customer/add',
    method: 'post',
    data
  })
}

export function appendProfileCustomer(data) {
  return Vue.axios({
    url: '/api/key_customer/append_customer_rel',
    method: 'post',
    data
  })
}

//关联销售-下拉框数据
export function saleProfileCustomerOption(data) {
  return Vue.axios({
    url: '/api/key_customer/sale_option',
    method: 'get',
    params: {
      ...data
    }
  })
}

//关联订单
export function adProfileCustomerList(data) {
  return Vue.axios({
    url: '/api/key_customer/ad_list',
    method: 'get',
    params: {
      ...data
    }
  })
}

//关联我的订单
export function myAdProfileCustomerList(data) {
  return Vue.axios({
    url: '/api/key_customer/my_ad_list',
    method: 'get',
    params: {
      ...data
    }
  })
}

export function editProfileCustomerTitle(data) {
  return Vue.axios({
    url: '/api/key_customer/edit',
    method: 'post',
    data
  })
}

//

/**
 * 更新数据
 * @param data
 * @returns {*}
 */
export function RefreshProfileCustomer(data) {
  return Vue.axios({
    url: '/api/key_customer/run_script',
    method: 'post',
    data
  })
}

/**
 * 删除
 * @param data
 * @returns {*}
 */
export function removeProfileCustomerInfo(data) {
  return Vue.axios({
    url: '/api/key_customer/remove_customer_rel',
    method: 'post',
    data
  })
}

/**
 * 删除
 * @param data
 * @returns {*}
 */
export function deleteProfileCustomer(data) {
  return Vue.axios({
    url: '/api/key_customer/delete',
    method: 'get',
    params: {
      ...data
    }
  })
}

/**
 * 查询用户
 * @param keyword
 * @returns {*}
 */
export function searchUserKeyCustomer(keyword) {
  return Vue.axios({
    url: '/api/key_customer/search_user',
    method: 'post',
    data: {
      keyword: keyword
    }
  })
}

/**
 * 分配记录
 * @param data
 * @returns {*}
 */
export function listScopeKeyCustomer(data) {
  return Vue.axios({
    url: '/api/key_customer/list_scope',
    method: 'get',
    params: {
      ...data
    }
  })
}

/**
 * 添加分配
 * @param data
 * @returns {*}
 */
export function addScopeKeyCustomer(data) {
  return Vue.axios({
    url: '/api/key_customer/add_scope',
    method: 'post',
    data
  })
}

/**
 * 移除分配
 * @param id
 * @returns {*}
 */
export function removeScopeKeyCustomer(id) {
  return Vue.axios({
    url: '/api/key_customer/remove_scope',
    method: 'post',
    params: {
      id: id
    }
  })
}

/**
 * 我的重点客户关联客户列表
 * @param data
 * @returns {*}
 */
export function getKeyCustomerRelCustomers(data) {
  return Vue.axios({
    url: '/api/key_customer/getRelCustomers',
    method: 'get',
    params: {
      ...data
    }
  })
}

/**
 *
 * @param params
 * @return {*}
 */
export function getKeyCustomerAmount(params) {
  return Vue.axios({
    url: '/api/key_customer/amount',
    method: 'get',
    params
  })
}
